var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramming(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 31,
    viewBox: "0 0 36 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.733887 30.0485V10.0498H1.07253H35.3678H35.7339V30.0943L0.733887 30.0485ZM17.7854 26.7719L20.696 13.656L18.7098 13.2167L15.7993 26.3325L17.7854 26.7719ZM13.3006 15.2669L8.54116 20.0263L13.2365 24.6942L14.6735 23.2572L11.3327 19.9256L14.6643 16.6032L13.3006 15.2669ZM27.9449 20.0171L23.1763 15.2577L21.7851 16.6856L25.1717 20.0629L21.8584 23.3762L23.2313 24.7491L27.9449 20.0171Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.733887 0.640808H35.7339V7.96299H0.733887V0.640808ZM7.75404 5.28124V3.27679H5.74959V5.28124H7.75404ZM14.3348 5.28124H16.2935V3.27679H14.3074L14.3348 5.28124ZM12.0283 5.28124V3.27679H10.0514V5.28124H12.0283Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramming);
export default __webpack_public_path__ + "static/media/programming.bd6d01fad032e66ade1669d8157222b4.svg";
export { ForwardRef as ReactComponent };